module.exports = __webpack_public_path__ + "img/slide_p3.aaee3b23.png";